import { render, staticRenderFns } from "./PasswordDetails.vue?vue&type=template&id=527a1c8f"
import script from "./PasswordDetails.vue?vue&type=script&lang=ts"
export * from "./PasswordDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports